<template>
    <div class="text-input-wrapper">
        <label
           v-if="label"
           class="input-label strong"
           :class="`input-label--${labelAlignment}`"
           :for="inputId"
        >
           {{ label }}
        </label>
        <input
           class="text-input"
           :class="{'error-glow': error}"
           v-if="!asTextArea"
           :id="inputId"
           :type="inputType"
           :placeholder="placeholder"
           :value="value"
           :required="required"
           @input="emitInput"
           :readonly="readonly"
        >
        <textarea
            class="text-input"
            :class="{'error-glow': error}"
            v-else
            :id="inputId"
            :required="required"
            :rows="rows"
            :placeholder="placeholder"
            :value="value"
            @input="emitInput"
            :readonly="readonly"
        ></textarea>
    </div>
</template>

<script>
import AutoFieldMixin from '../../mixins/AutoField'

export default {
  name: 'TextInput',
  mixins: [AutoFieldMixin],
  props: {
    value: {
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    labelAlignment: {
      type: String,
      default: 'left'
    },
    placeholder: {
      type: String,
      default: ''
    },
    inputId: {
      type: String,
      required: true
    },
    inputType: {
      type: String,
      default: 'text'
    },
    inputValueType: {
      type: String,
      default: 'string'
    },
    asTextArea: {
      type: Boolean,
      default: false
    },
    error: {
        type: Boolean,
        default: false
    },
    rows: {
      type: Number,
      required: false
    },
    readonly: Boolean,
  },
  computed: {
    isValueTypeValid() {
      return typeof this.value === this.inputValueType
    },
    defaultValue() {
      return ''
    }
  },
  methods: {
    valueToSendFromEvent(e) {
      const value = e.target.value
      if (this.inputValueType === 'number') {
        return Number(value)
      } else {
        return value
      }
    },
    preEmitHook(e) {
      this.valueStr = e.target.value
    },
    valueIsEmpty() {
      return this.valueStr === ''
    }
  }
}
</script>

<style scoped lang="sass">
    .text-input-wrapper
        display: flex
        flex-flow: column
        margin-bottom: gridSteps(2)

    .input-label
        margin-bottom: gridSteps(1)
        &--center
            margin-left: auto
            margin-right: auto

    .text-input
        border-radius: pxToRem(5px)
        border: 1px solid $grey
        font-size: $base-font-size
        font-weight: 300
        padding: gridSteps(1)

        &:focus
            outline-color: $brand-blue

</style>
